/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

export const useCommonMarketoStore = defineStore('mkto_common', {
  state: () => ({
    utmcampaign: '',
    utmmedium: '',
    utmsource: '',
    utmcontent: '',
    utmterm: '',
    utm_visits__c: '',
    utm_initial_landing_page__c: '',
    utm_initial_point_of_origin__c: '',
    utm_last_landing_page__c: '',
    Sales_Token__c: '',
    Partner_Token__c: '',
    Promotion__c: '',
    GCLID__c: '',
    Facebook_Click_ID__c: '',
    Google_User_ID__c: '',
    LinkedIn_Click_ID__c: '',
    Microsoft_Click_ID__c: '',
    mops_xid: '',
    munchkinId: '',
  }),
});
